import { language_utility } from "./language_utility"
import { language_cataloging } from './language_cataloging'
import { language_koha } from "./language_koha"
//#region 公用區
const cataloging = {
    'zh-tw': "編目",
    en: "Cataloging"
}
const circulation = {
    'zh-tw': "流通",
    en: "Circulation"
}
const patron = {
    'zh-tw': "讀者",
    en: "Patron"
}
const patrons = {
    'zh-tw': "讀者",
    en: "Patrons"
}
const patronCategories = {
    'zh-tw': "讀者類型",
    en: "Patron Categories"
}
const patronCategory = {
    'zh-tw': "讀者類型",
    en: "Patron Category"
}
const checkout = {
    'zh-tw': "借書",
    en: "Checkout"
}
const hold = {
    'zh-tw': "預約",
    en: "Hold"
}
const hold_priority = {
    'zh-tw': "預約順序",
    en: "Hold Priority"
}
const circulation_policy = {
    'zh-tw': "流通規則",
    en: "Circulation Policy"
}
const renew = {
    'zh-tw': "續借",
    en: "Renew"
}
const add_record = {
    'zh-tw': "新增書目",
    en: "Add Record"
}
const edit_record = {
    'zh-tw': "編輯書目",
    en: "Edit Record"
}
const delete_record = {
    'zh-tw': "刪除書目",
    en: "Delete Record"
}
const search_z3950 = {
    'zh-tw': "Z39.50搜尋",
    en: "Z39.50 Search"
}
const Keyword = {
    'zh-tw': "關鍵字",
    en: "Keyword"
}
const Title = {
    'zh-tw': "書名",
    en: "Title"
}
const Author = {
    'zh-tw': "作者",
    en: "Author"
}
const Subject = {
    'zh-tw': "主題",
    en: "Subject(s)"
}
const Material_type = {
    'zh-tw': "資料類型",
    en: "Material type"
}
const Series = {
    'zh-tw': "集叢名",
    en: "Series"
}
const Year = {
    'zh-tw': "出版年",
    en: "Year"
}
const Edition = {
    'zh-tw': "版本",
    en: "Edition"
}
const Publication_details = {
    'zh-tw': "出版細節",
    en: "Publication details"
}
const Description = {
    'zh-tw': "說明",
    en: "Description"
}
const Other_title = {
    'zh-tw': "其他題名",
    en: "Other title"
}
const Barcode = {
    'zh-tw': "條碼",
    en: "Barcode"
}
const Item_call_number = {
    'zh-tw': "索書號",
    en: "Item call number"
}
const Item_type = {
    'zh-tw': "館藏類型",
    en: "Item type"
}
const Actions = {
    'zh-tw': "功能",
    en: "Actions"
}
const frontend_basic_settings = {
    'zh-tw': "系統前台基本資料設定",
    en: "Frontend Basic Settings",
}
const backend_basic_settings = {
    'zh-tw': "系統後台基本資料設定",
    en: "Backend Basic Settings",
}
const finishMessage = {
    add_success: {
        'zh-tw': "新增成功",
        en: "Add Successful",
    },
    modify_success: {
        'zh-tw': "修改成功",
        en: "Modify Successful",
    },
    delete_success: {
        'zh-tw': "刪除成功",
        en: "Delete Successful",
    },
    add_failure: {
        'zh-tw': "新增失敗",
        en: "Add Failure",
    },
    modify_failure: {
        'zh-tw': "修改失敗",
        en: "Modify Failure",
    },
    delete_failure: {
        'zh-tw': "刪除失敗",
        en: "Delete Failure",
    },
}

//#endregion

const language_library = {
    'zh-tw': "圖書自動化系統",
    en: "",
    children: {
        backstage: {
            'zh-tw': "後台管理",
            en: "Backstage",
            children: {
                AddMARC: { ...add_record, children: {} },
                EditMARC: {
                    ...edit_record,
                    children: {

                    }
                },
                DeleteMARC: {
                    ...delete_record,
                    children: {

                    }
                },
                SearchZ3950: { ...search_z3950, children: {} },
                ManageMARCRecord: {
                    'zh-tw': "管理書目",
                    en: "Manage Record",
                    children: {}
                },
                BookDetail: {
                    'zh-tw': "書目內容",
                    en: "Information",
                    children: {}
                },
                AddItem: {
                    'zh-tw': "新增館藏",
                    en: "Add Item",
                    children: {}
                },
                EditItem: {
                    'zh-tw': "編輯館藏",
                    en: "Edit Item",
                    children: {}
                },
                BookDetailItems: {
                    'zh-tw': "館藏詳細內容",
                    en: "Item Detail",
                    children: {}
                },
                UploadImage: {
                    'zh-tw': "上傳圖片",
                    en: "Upload Image",
                    children: {}
                },
                StageMARCRecord: {
                    'zh-tw': "匯入 MARC 記錄",
                    en: "Cataloging",
                    children: {}
                },
                LabelPrint: {
                    'zh-tw': "標籤製作",
                    en: "Label Record",
                    children: {}
                },
                Cataloging: {
                    'zh-tw': "編目",
                    en: "Cataloging",
                    children: {}
                },
                ReaderService: {
                    'zh-tw': "個人書房",
                    en: "Manage Record",
                    children: {}
                },
                authority: {
                    'zh-tw': "權威控制",
                    en: "Authority",
                    children: {

                    }
                },
                Circulation: {
                    ...circulation,
                    children: {
                        CheckOut: {
                            ...checkout,
                            children: {
                                borrowed: {
                                    'zh-tw': "已借閱",
                                    en: "Borrowed",
                                },
                                reservation: {
                                    'zh-tw': "預約",
                                    en: "Reservation",
                                },
                                declaration: {
                                    'zh-tw': "聲明",
                                    en: "Declaration",
                                },
                                restriction: {
                                    'zh-tw': "限制",
                                    en: "Restriction",
                                },
                                reader_list: {
                                    'zh-tw': "讀者列表",
                                    en: "Reader List",
                                },
                                manual_add_restriction: {
                                    'zh-tw': "手動新增限制",
                                    en: "Manual Add Restriction",
                                },
                                patron_unrestricted: {
                                    'zh-tw': "讀者目前無限制",
                                    en: "Patron is currently unrestricted",
                                },
                                borrow: {
                                    'zh-tw': "借書",
                                    en: "Borrow",
                                },
                                edit: {
                                    'zh-tw': "編輯",
                                    en: "Edit",
                                },
                                change_password: {
                                    'zh-tw': "更改密碼",
                                    en: "Change Password",
                                },
                                copy: {
                                    'zh-tw': "複製",
                                    en: "Copy",
                                },
                                search_reserve: {
                                    'zh-tw': "搜尋預留",
                                    en: "Search Reserve",
                                },
                                print: {
                                    'zh-tw': "列印",
                                    en: "Print",
                                },
                                print_summary: {
                                    'zh-tw': "列印摘要",
                                    en: "Print Summary",
                                },
                                print_slip: {
                                    'zh-tw': "列印單據",
                                    en: "Print Slip",
                                },
                                print_quick_slip: {
                                    'zh-tw': "快速列印單據",
                                    en: "Print Quick Slip",
                                },
                                print_checkin_slip: {
                                    'zh-tw': "列印還書單據",
                                    en: "Print Checkin Slip",
                                },
                                add_message: {
                                    'zh-tw': "新增訊息",
                                    en: "Add Message",
                                },
                                more: {
                                    'zh-tw': "更多",
                                    en: "More",
                                },
                                renew_patron: {
                                    'zh-tw': "續借讀者",
                                    en: "Renew Patron",
                                },
                                set_permissions: {
                                    'zh-tw': "設定權限",
                                    en: "Set Permissions",
                                },
                                manage_api_key: {
                                    'zh-tw': "管理 API 金鑰",
                                    en: "Manage API Key",
                                },
                                send_welcome_email: {
                                    'zh-tw': "發送歡迎郵件",
                                    en: "Send Welcome Email",
                                },
                                delete: {
                                    'zh-tw': "刪除",
                                    en: "Delete",
                                },
                                message: {
                                    'zh-tw': "訊息",
                                    en: "Message",
                                },
                                add_new_message: {
                                    'zh-tw': "新增訊息",
                                    en: "Add New Message",
                                },
                                patron: {
                                    'zh-tw': "借書人",
                                    en: "Patron",
                                },
                                borrowing: {
                                    'zh-tw': "借閱",
                                    en: "Borrowing",
                                },
                                library_collection_borrowing: {
                                    'zh-tw': "館藏借閱",
                                    en: "Library Collection Borrowing",
                                },
                                cancel: {
                                    'zh-tw': "取消",
                                    en: "Cancel",
                                },
                                book_not_found: {
                                    'zh-tw': "找無此書",
                                    en: "Book Not Found",
                                },
                                pickup_branch: {
                                    'zh-tw': "取書分館",
                                    en: "Pickup Branch",
                                },
                                previous_step: {
                                    'zh-tw': "上一步",
                                    en: "Previous Step",
                                },
                                address: {
                                    'zh-tw': "地址",
                                    en: "Address",
                                },
                                city: {
                                    'zh-tw': "城市",
                                    en: "City",
                                },
                                phone: {
                                    'zh-tw': "電話",
                                    en: "Phone",
                                },
                                email: {
                                    'zh-tw': "電子郵件",
                                    en: "Email",
                                },
                                birthday: {
                                    'zh-tw': "生日",
                                    en: "Birthday",
                                },
                                type: {
                                    'zh-tw': "類型",
                                    en: "Type",
                                },
                                affiliated_library: {
                                    'zh-tw': "所屬圖書館",
                                    en: "Affiliated Library",
                                },
                                patron_id: {
                                    'zh-tw': "讀者編號",
                                    en: "Patron ID",
                                },
                                last_update_time: {
                                    'zh-tw': "最後更新時間",
                                    en: "Last Update Time",
                                },
                                borrowed_list: {
                                    children: {
                                        borrowernumber: {
                                            'zh-tw': "借書人編號",
                                            en: "borrowernumber",
                                        },
                                        return_selected_items: {
                                            'zh-tw': "歸還勾選項目",
                                            en: "Return Selected Items",
                                        },
                                        renew_selected_items: {
                                            'zh-tw': "續借勾選項目",
                                            en: "Renew Selected Items",
                                        },
                                        renew_all_items: {
                                            'zh-tw': "續借所有項目",
                                            en: "Renew All Items",
                                        },
                                        due_date: {
                                            'zh-tw': "到期日",
                                            en: "Due Date",
                                        },
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        category: {
                                            'zh-tw': "種類",
                                            en: "Category",
                                        },
                                        collection: {
                                            'zh-tw': "藏書",
                                            en: "Collection",
                                        },
                                        location: {
                                            'zh-tw': "藏書位置",
                                            en: "Location",
                                        },
                                        original_library: {
                                            'zh-tw': "原圖書館",
                                            en: "Original Library",
                                        },
                                        borrow_date: {
                                            'zh-tw': "借出日期",
                                            en: "Borrow Date",
                                        },
                                        borrow_library: {
                                            'zh-tw': "借出圖書館",
                                            en: "Borrow Library",
                                        },
                                        fee: {
                                            'zh-tw': "費用",
                                            en: "Fee",
                                        },
                                        fine: {
                                            'zh-tw': "罰金",
                                            en: "Fine",
                                        },
                                        price: {
                                            'zh-tw': "價格",
                                            en: "Price",
                                        },
                                        action: {
                                            'zh-tw': "操作",
                                            en: "Action",
                                        },
                                        return: {
                                            'zh-tw': "還書",
                                            en: "Return",
                                        },
                                        renew: {
                                            'zh-tw': "續借",
                                            en: "Renew",
                                        },
                                        delete_record: {
                                            'zh-tw': "刪除借閱紀錄",
                                            en: "Delete Record",
                                        },
                                        delete_borrower_record: {
                                            'zh-tw': "要刪除人員借閱紀錄的帳號",
                                            en: "Delete Borrower Record",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        issue_borrowername: {
                                            'zh-tw': "借閱讀者",
                                            en: "Issue Borrowername",
                                        },
                                    }
                                }
                            }
                        },
                        CheckOutSetting: {
                            ...checkout,
                            children: {
                                patron: {
                                    'zh-tw': "借書人",
                                    en: "Patron",
                                },
                                previous_step: {
                                    'zh-tw': "上一步",
                                    en: "Previous Step",
                                },
                                address: {
                                    'zh-tw': "地址",
                                    en: "Address",
                                },
                                city: {
                                    'zh-tw': "城市",
                                    en: "City",
                                },
                                phone: {
                                    'zh-tw': "電話",
                                    en: "Phone",
                                },
                                email: {
                                    'zh-tw': "電子郵件",
                                    en: "Email",
                                },
                                birthday: {
                                    'zh-tw': "生日",
                                    en: "Birthday",
                                },
                                type: {
                                    'zh-tw': "類型",
                                    en: "Type",
                                },
                                affiliated_library: {
                                    'zh-tw': "所屬圖書館",
                                    en: "Affiliated Library",
                                },
                                patron_id: {
                                    'zh-tw': "讀者編號",
                                    en: "Patron ID",
                                },
                                last_update_time: {
                                    'zh-tw': "最後更新時間",
                                    en: "Last Update Time",
                                },
                                borrowed_list: {
                                    children: {
                                        return_selected_items: {
                                            'zh-tw': "歸還勾選項目",
                                            en: "Return Selected Items",
                                        },
                                        renew_selected_items: {
                                            'zh-tw': "續借勾選項目",
                                            en: "Renew Selected Items",
                                        },
                                        renew_all_items: {
                                            'zh-tw': "續借所有項目",
                                            en: "Renew All Items",
                                        },
                                        due_date: {
                                            'zh-tw': "到期日",
                                            en: "Due Date",
                                        },
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        category: {
                                            'zh-tw': "種類",
                                            en: "Category",
                                        },
                                        collection: {
                                            'zh-tw': "藏書",
                                            en: "Collection",
                                        },
                                        location: {
                                            'zh-tw': "藏書位置",
                                            en: "Location",
                                        },
                                        original_library: {
                                            'zh-tw': "原圖書館",
                                            en: "Original Library",
                                        },
                                        borrow_date: {
                                            'zh-tw': "借出日期",
                                            en: "Borrow Date",
                                        },
                                        borrow_library: {
                                            'zh-tw': "借出圖書館",
                                            en: "Borrow Library",
                                        },
                                        fee: {
                                            'zh-tw': "費用",
                                            en: "Fee",
                                        },
                                        fine: {
                                            'zh-tw': "罰金",
                                            en: "Fine",
                                        },
                                        price: {
                                            'zh-tw': "價格",
                                            en: "Price",
                                        },
                                        action: {
                                            'zh-tw': "操作",
                                            en: "Action",
                                        },
                                        return: {
                                            'zh-tw': "還書",
                                            en: "Return",
                                        },
                                        renew: {
                                            'zh-tw': "續借",
                                            en: "Renew",
                                        },
                                        post_checkout: {
                                            'zh-tw': "新增借書",
                                            en: "Post Checkout",
                                        },
                                        borrowernumber: {
                                            'zh-tw': "讀者編號編號",
                                            en: "Borrowernumber",
                                        },
                                        itemnumber: {
                                            'zh-tw': "書目編號",
                                            en: "Itemnumber",
                                        },
                                        issue_date_due: {
                                            'zh-tw': "到期日",
                                            en: "Issue Date Due",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        post: {
                                            'zh-tw': "新增",
                                            en: "post",
                                        },
                                        edit: {
                                            'zh-tw': "編輯",
                                            en: "edit",
                                        },
                                        checkin_renew: {
                                            'zh-tw': "還書與續借",
                                            en: "Checkin and Renew",
                                        },
                                    }
                                },
                                items: {
                                    children: {
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        collection_id: {
                                            'zh-tw': "館藏編號",
                                            en: "Collection ID",
                                        },
                                        collection_type: {
                                            'zh-tw': "館藏種類",
                                            en: "Collection Type",
                                        },
                                        barcode: {
                                            'zh-tw': "條碼",
                                            en: "Barcode",
                                        },
                                        collection_branch: {
                                            'zh-tw': "永久歸屬分館(書的原屬地)",
                                            en: "Collection Branch",
                                        },
                                        current_location: {
                                            'zh-tw': "當前所在分館(實際存放地)",
                                            en: "Current Location",
                                        },
                                        call_number: {
                                            'zh-tw': "索書號",
                                            en: "Call Number",
                                        },
                                        copy_id: {
                                            'zh-tw': "複本編號",
                                            en: "Copy ID",
                                        },
                                        hold: {
                                            'zh-tw': "預約",
                                            en: "Hold",
                                        },
                                        hold_setting: {
                                            'zh-tw': "預約設定",
                                            en: "Hold Setting",
                                        },
                                        pickup_library: {
                                            'zh-tw': "領取校區",
                                            en: "Pickup Library",
                                        },
                                        expiration_date: {
                                            'zh-tw': "預約有效期",
                                            en: "Expiration Date",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        checkout: {
                                            'zh-tw': "借閱",
                                            en: "Checkout",
                                        },
                                        borrowernumber: {
                                            'zh-tw': "讀者編號",
                                            en: "Borrowernumber",
                                        },
                                        itemnumber: {
                                            'zh-tw': "館藏編號",
                                            en: "Itemnumber",
                                        },
                                        issue_date_due: {
                                            'zh-tw': "到期日",
                                            en: "Issue Date Due",
                                        },
                                        due_date: {
                                            'zh-tw': "到期日",
                                            en: "Due Date",
                                        },
                                        cardnumber: {
                                            'zh-tw': "卡號",
                                            en: "Card Number",
                                        },
                                        branchcode: {
                                            'zh-tw': "分館代碼",
                                            en: "Branch Code",
                                        },
                                        branchname: {
                                            'zh-tw': "所屬分館",
                                            en: "Branch Name",
                                        },
                                        borrowercategory: {
                                            'zh-tw': "讀者分類",
                                            en: "Borrower Category",
                                        },
                                        borrowernumber: {
                                            'zh-tw': "讀者編號",
                                            en: "Borrower Number",
                                        },
                                        search: {
                                            'zh-tw': "查詢",
                                            en: "Search",
                                        },
                                        clear: {
                                            'zh-tw': "清除",
                                            en: "Clear",
                                        },
                                        biblionumber: {
                                            'zh-tw': "書目編號",
                                            en: "Biblionumber",
                                        },
                                    }
                                }
                            }
                        },
                        RenewSetting: {
                            ...renew,
                            children: {
                                patron: {
                                    'zh-tw': "借書人",
                                    en: "Patron",
                                },
                                previous_step: {
                                    'zh-tw': "上一步",
                                    en: "Previous Step",
                                },
                                address: {
                                    'zh-tw': "地址",
                                    en: "Address",
                                },
                                city: {
                                    'zh-tw': "城市",
                                    en: "City",
                                },
                                phone: {
                                    'zh-tw': "電話",
                                    en: "Phone",
                                },
                                email: {
                                    'zh-tw': "電子郵件",
                                    en: "Email",
                                },
                                birthday: {
                                    'zh-tw': "生日",
                                    en: "Birthday",
                                },
                                type: {
                                    'zh-tw': "類型",
                                    en: "Type",
                                },
                                affiliated_library: {
                                    'zh-tw': "所屬圖書館",
                                    en: "Affiliated Library",
                                },
                                patron_id: {
                                    'zh-tw': "讀者編號",
                                    en: "Patron ID",
                                },
                                last_update_time: {
                                    'zh-tw': "最後更新時間",
                                    en: "Last Update Time",
                                },
                                borrowed_list: {
                                    children: {
                                        return_selected_items: {
                                            'zh-tw': "歸還勾選項目",
                                            en: "Return Selected Items",
                                        },
                                        renew_selected_items: {
                                            'zh-tw': "續借勾選項目",
                                            en: "Renew Selected Items",
                                        },
                                        renew_all_items: {
                                            'zh-tw': "續借所有項目",
                                            en: "Renew All Items",
                                        },
                                        due_date: {
                                            'zh-tw': "到期日",
                                            en: "Due Date",
                                        },
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        category: {
                                            'zh-tw': "種類",
                                            en: "Category",
                                        },
                                        collection: {
                                            'zh-tw': "藏書",
                                            en: "Collection",
                                        },
                                        location: {
                                            'zh-tw': "藏書位置",
                                            en: "Location",
                                        },
                                        original_library: {
                                            'zh-tw': "原圖書館",
                                            en: "Original Library",
                                        },
                                        borrow_date: {
                                            'zh-tw': "借出日期",
                                            en: "Borrow Date",
                                        },
                                        borrow_library: {
                                            'zh-tw': "借出圖書館",
                                            en: "Borrow Library",
                                        },
                                        fee: {
                                            'zh-tw': "費用",
                                            en: "Fee",
                                        },
                                        fine: {
                                            'zh-tw': "罰金",
                                            en: "Fine",
                                        },
                                        price: {
                                            'zh-tw': "價格",
                                            en: "Price",
                                        },
                                        action: {
                                            'zh-tw': "操作",
                                            en: "Action",
                                        },
                                        return: {
                                            'zh-tw': "還書",
                                            en: "Return",
                                        },
                                        renew: {
                                            'zh-tw': "續借",
                                            en: "Renew",
                                        },
                                        issue_id: {
                                            'zh-tw': "借閱編號",
                                            en: "Issue Id",
                                        },
                                        post_checkout: {
                                            'zh-tw': "新增借書",
                                            en: "Post Checkout",
                                        },
                                        borrowernumber: {
                                            'zh-tw': "讀者編號",
                                            en: "Borrowernumber",
                                        },
                                        itemnumber: {
                                            'zh-tw': "書目編號",
                                            en: "Itemnumber",
                                        },
                                        issue_date_due: {
                                            'zh-tw': "到期日",
                                            en: "Issue Date Due",
                                        },
                                        date_due: {
                                            'zh-tw': "到期日",
                                            en: "Date Due",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        post: {
                                            'zh-tw': "新增",
                                            en: "post",
                                        },
                                        edit: {
                                            'zh-tw': "編輯",
                                            en: "edit",
                                        },
                                        issue_borrowernumber: {
                                            'zh-tw': "借閱讀者編號",
                                            en: "Issue Borrowernumber",
                                        },
                                        issue_borrowername: {
                                            'zh-tw': "借閱讀者",
                                            en: "Issue Borrowername",
                                        },
                                    }
                                }
                            }
                        },
                        HoldSetting: {
                            ...hold,
                            children: {
                                patron: {
                                    'zh-tw': "借書人",
                                    en: "Patron",
                                },
                                previous_step: {
                                    'zh-tw': "上一步",
                                    en: "Previous Step",
                                },
                                address: {
                                    'zh-tw': "地址",
                                    en: "Address",
                                },
                                city: {
                                    'zh-tw': "城市",
                                    en: "City",
                                },
                                phone: {
                                    'zh-tw': "電話",
                                    en: "Phone",
                                },
                                email: {
                                    'zh-tw': "電子郵件",
                                    en: "Email",
                                },
                                birthday: {
                                    'zh-tw': "生日",
                                    en: "Birthday",
                                },
                                type: {
                                    'zh-tw': "類型",
                                    en: "Type",
                                },
                                affiliated_library: {
                                    'zh-tw': "所屬圖書館",
                                    en: "Affiliated Library",
                                },
                                patron_id: {
                                    'zh-tw': "讀者編號",
                                    en: "Patron ID",
                                },
                                last_update_time: {
                                    'zh-tw': "最後更新時間",
                                    en: "Last Update Time",
                                },
                                hold: {
                                    'zh-tw': "預約",
                                    en: "Hold",
                                },
                                borrowed_list: {
                                    children: {
                                        return_selected_items: {
                                            'zh-tw': "歸還勾選項目",
                                            en: "Return Selected Items",
                                        },
                                        renew_selected_items: {
                                            'zh-tw': "續借勾選項目",
                                            en: "Renew Selected Items",
                                        },
                                        renew_all_items: {
                                            'zh-tw': "續借所有項目",
                                            en: "Renew All Items",
                                        },
                                        due_date: {
                                            'zh-tw': "到期日",
                                            en: "Due Date",
                                        },
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        category: {
                                            'zh-tw': "種類",
                                            en: "Category",
                                        },
                                        collection: {
                                            'zh-tw': "藏書",
                                            en: "Collection",
                                        },
                                        location: {
                                            'zh-tw': "藏書位置",
                                            en: "Location",
                                        },
                                        original_library: {
                                            'zh-tw': "原圖書館",
                                            en: "Original Library",
                                        },
                                        borrow_date: {
                                            'zh-tw': "借出日期",
                                            en: "Borrow Date",
                                        },
                                        borrow_library: {
                                            'zh-tw': "借出圖書館",
                                            en: "Borrow Library",
                                        },
                                        fee: {
                                            'zh-tw': "費用",
                                            en: "Fee",
                                        },
                                        fine: {
                                            'zh-tw': "罰金",
                                            en: "Fine",
                                        },
                                        price: {
                                            'zh-tw': "價格",
                                            en: "Price",
                                        },
                                        action: {
                                            'zh-tw': "操作",
                                            en: "Action",
                                        },
                                        return: {
                                            'zh-tw': "還書",
                                            en: "Return",
                                        },
                                        renew: {
                                            'zh-tw': "續借",
                                            en: "Renew",
                                        },
                                        post_checkout: {
                                            'zh-tw': "新增借書",
                                            en: "Post Checkout",
                                        },
                                        borrowernumber: {
                                            'zh-tw': "讀者編號",
                                            en: "Borrowernumber",
                                        },
                                        itemnumber: {
                                            'zh-tw': "書目編號",
                                            en: "Itemnumber",
                                        },
                                        issue_date_due: {
                                            'zh-tw': "到期日",
                                            en: "Issue Date Due",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        post: {
                                            'zh-tw': "新增",
                                            en: "post",
                                        },
                                        edit: {
                                            'zh-tw': "編輯",
                                            en: "edit",
                                        },
                                        checkin_renew: {
                                            'zh-tw': "還書與續借",
                                            en: "Checkin and Renew",
                                        }
                                    }
                                },
                                items: {
                                    children: {
                                        collection_id: {
                                            'zh-tw': "館藏編號",
                                            en: "Collection ID",
                                        },
                                        collection_type: {
                                            'zh-tw': "館藏種類",
                                            en: "Collection Type",
                                        },
                                        barcode: {
                                            'zh-tw': "條碼",
                                            en: "Barcode",
                                        },
                                        collection_branch: {
                                            'zh-tw': "永久歸屬分館(書的原屬地)",
                                            en: "Collection Branch",
                                        },
                                        current_location: {
                                            'zh-tw': "當前所在分館(實際存放地)",
                                            en: "Current Location",
                                        },
                                        call_number: {
                                            'zh-tw': "索書號",
                                            en: "Call Number",
                                        },
                                        copy_id: {
                                            'zh-tw': "複本編號",
                                            en: "Copy ID",
                                        },
                                        hold: {
                                            'zh-tw': "預約",
                                            en: "Hold",
                                        },
                                        hold_setting: {
                                            'zh-tw': "預約設定",
                                            en: "Hold Setting",
                                        },
                                        pickup_library: {
                                            'zh-tw': "領取分館",
                                            en: "Pickup Library",
                                        },
                                        expiration_date: {
                                            'zh-tw': "預約有效期",
                                            en: "Expiration Date",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        borrowernumber: {
                                            'zh-tw': "讀者編號",
                                            en: "Borrowernumber",
                                        },
                                        itemnumber: {
                                            'zh-tw': "書目編號",
                                            en: "Itemnumber",
                                        },
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        reserve_number: {
                                            'zh-tw': "預約人數",
                                            en: "Reserve Number",
                                        },
                                        action: {
                                            'zh-tw': "操作",
                                            en: "Action",
                                        },
                                    }
                                }
                            }
                        },
                        HoldPriority: {
                            ...hold_priority,
                            children: {
                                patron: {
                                    'zh-tw': "借書人",
                                    en: "Patron",
                                },
                                previous_step: {
                                    'zh-tw': "上一步",
                                    en: "Previous Step",
                                },
                                address: {
                                    'zh-tw': "地址",
                                    en: "Address",
                                },
                                city: {
                                    'zh-tw': "城市",
                                    en: "City",
                                },
                                phone: {
                                    'zh-tw': "電話",
                                    en: "Phone",
                                },
                                email: {
                                    'zh-tw': "電子郵件",
                                    en: "Email",
                                },
                                birthday: {
                                    'zh-tw': "生日",
                                    en: "Birthday",
                                },
                                type: {
                                    'zh-tw': "類型",
                                    en: "Type",
                                },
                                affiliated_library: {
                                    'zh-tw': "所屬圖書館",
                                    en: "Affiliated Library",
                                },
                                patron_id: {
                                    'zh-tw': "讀者編號",
                                    en: "Patron ID",
                                },
                                last_update_time: {
                                    'zh-tw': "最後更新時間",
                                    en: "Last Update Time",
                                },
                                hold: {
                                    'zh-tw': "預約",
                                    en: "Hold",
                                },
                                borrowed_list: {
                                    children: {
                                        return_selected_items: {
                                            'zh-tw': "歸還勾選項目",
                                            en: "Return Selected Items",
                                        },
                                        renew_selected_items: {
                                            'zh-tw': "續借勾選項目",
                                            en: "Renew Selected Items",
                                        },
                                        renew_all_items: {
                                            'zh-tw': "續借所有項目",
                                            en: "Renew All Items",
                                        },
                                        due_date: {
                                            'zh-tw': "到期日",
                                            en: "Due Date",
                                        },
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        category: {
                                            'zh-tw': "種類",
                                            en: "Category",
                                        },
                                        collection: {
                                            'zh-tw': "藏書",
                                            en: "Collection",
                                        },
                                        location: {
                                            'zh-tw': "藏書位置",
                                            en: "Location",
                                        },
                                        original_library: {
                                            'zh-tw': "原圖書館",
                                            en: "Original Library",
                                        },
                                        borrow_date: {
                                            'zh-tw': "借出日期",
                                            en: "Borrow Date",
                                        },
                                        borrow_library: {
                                            'zh-tw': "借出圖書館",
                                            en: "Borrow Library",
                                        },
                                        fee: {
                                            'zh-tw': "費用",
                                            en: "Fee",
                                        },
                                        fine: {
                                            'zh-tw': "罰金",
                                            en: "Fine",
                                        },
                                        price: {
                                            'zh-tw': "價格",
                                            en: "Price",
                                        },
                                        action: {
                                            'zh-tw': "操作",
                                            en: "Action",
                                        },
                                        return: {
                                            'zh-tw': "還書",
                                            en: "Return",
                                        },
                                        renew: {
                                            'zh-tw': "續借",
                                            en: "Renew",
                                        },
                                        post_checkout: {
                                            'zh-tw': "新增借書",
                                            en: "Post Checkout",
                                        },
                                        borrowernumber: {
                                            'zh-tw': "讀者編號",
                                            en: "Borrowernumber",
                                        },
                                        itemnumber: {
                                            'zh-tw': "書目編號",
                                            en: "Itemnumber",
                                        },
                                        issue_date_due: {
                                            'zh-tw': "到期日",
                                            en: "Issue Date Due",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        post: {
                                            'zh-tw': "新增",
                                            en: "post",
                                        },
                                        edit: {
                                            'zh-tw': "編輯",
                                            en: "edit",
                                        },
                                        checkin_renew: {
                                            'zh-tw': "還書與續借",
                                            en: "Checkin and Renew",
                                        }
                                    }
                                },
                                items: {
                                    children: {
                                        collection_id: {
                                            'zh-tw': "館藏編號",
                                            en: "Collection ID",
                                        },
                                        collection_type: {
                                            'zh-tw': "館藏種類",
                                            en: "Collection Type",
                                        },
                                        barcode: {
                                            'zh-tw': "條碼",
                                            en: "Barcode",
                                        },
                                        collection_branch: {
                                            'zh-tw': "永久歸屬分館(書的原屬地)",
                                            en: "Collection Branch",
                                        },
                                        current_location: {
                                            'zh-tw': "當前所在分館(實際存放地)",
                                            en: "Current Location",
                                        },
                                        call_number: {
                                            'zh-tw': "索書號",
                                            en: "Call Number",
                                        },
                                        copy_id: {
                                            'zh-tw': "複本編號",
                                            en: "Copy ID",
                                        },
                                        hold: {
                                            'zh-tw': "預約",
                                            en: "Hold",
                                        },
                                        hold_priority: {
                                            'zh-tw': "預約順序調整",
                                            en: "Hold Priority",
                                        },
                                        hold_setting: {
                                            'zh-tw': "預約設定",
                                            en: "Hold Setting",
                                        },
                                        pickup_library: {
                                            'zh-tw': "領取分館",
                                            en: "Pickup Library",
                                        },
                                        expiration_date: {
                                            'zh-tw': "預約有效期",
                                            en: "Expiration Date",
                                        },
                                        ok: {
                                            'zh-tw': "確認",
                                            en: "ok",
                                        },
                                        cancel: {
                                            'zh-tw': "取消",
                                            en: "cancel",
                                        },
                                        holds_number: {
                                            'zh-tw': "預約人數",
                                            en: "Holds Number",
                                        },
                                    }
                                }
                            }
                        },
                        Rules: {
                            ...circulation_policy,
                            children: {
                                defining_circulation_and_fine_rules: {
                                    'zh-tw': "為所有館藏設定流通與罰款規則",
                                    en: "Defining circulation and fine rules for all libraries",
                                },
                                rules_application_order: {
                                    'zh-tw': "規則應用順序：由最具體至較不具體，依下列順序進行",
                                    en: "The rules are applied from most specific to less specific, using the first found in this order:",
                                },
                                same_library_same_patron_same_item: {
                                    'zh-tw': "相同圖書館、相同讀者類別、相同館藏類型",
                                    en: "same library, same patron category, same item type",
                                },
                                same_library_same_patron_all_items: {
                                    'zh-tw': "相同圖書館、相同讀者類別、所有館藏類型",
                                    en: "same library, same patron category, all item types",
                                },
                                same_library_all_patrons_same_item: {
                                    'zh-tw': "相同圖書館、所有讀者類別、相同館藏類型",
                                    en: "same library, all patron categories, same item type",
                                },
                                same_library_all_patrons_all_items: {
                                    'zh-tw': "相同圖書館、所有讀者類別、所有館藏類型",
                                    en: "same library, all patron categories, all item types",
                                },
                                default_same_patron_same_item: {
                                    'zh-tw': "預設（所有圖書館）、相同讀者類別、相同館藏類型",
                                    en: "default (all libraries), same patron category, same item type",
                                },
                                default_same_patron_all_items: {
                                    'zh-tw': "預設（所有圖書館）、相同讀者類別、所有館藏類型",
                                    en: "default (all libraries), same patron category, all item types",
                                },
                                default_all_patrons_same_item: {
                                    'zh-tw': "預設（所有圖書館）、所有讀者類別、相同館藏類型",
                                    en: "default (all libraries), all patron categories, same item type",
                                },
                                default_all_patrons_all_items: {
                                    'zh-tw': "預設（所有圖書館）、所有讀者類別、所有館藏類型",
                                    en: "default (all libraries), all patron categories, all item types",
                                },
                                parent_child_rule_note: {
                                    'zh-tw': "若館藏類型有父類型，則規則將顯示為「父類型->子類型」，而當前可借閱數量將以父類型的最大數量（計算兄弟類型）或特定規則的類型為限，取其較少者。",
                                    en: "Where an itemtype has a parent, the rule will display as 'Parent->Child' and the number of current checkouts allowed will be limited to either the maximum for the parent (counting sibling types) or the specific rule's type, whichever is less.",
                                },
                                modify_rule_instruction: {
                                    'zh-tw': "要修改規則，請使用相同的讀者類別和館藏類型創建新規則。",
                                    en: "To modify a rule, create a new one with the same patron category and item type.",
                                },


                                default_checkout_hold_return_policy: {
                                    'zh-tw': "預設借閱、預約和歸還政策",
                                    en: "Default checkout, hold and return policy",
                                },
                                default_max_checkouts_info: {
                                    'zh-tw': "您可以設置預設的最大借閱數量、預約政策和歸還政策，若特定館藏類型或讀者類別下未定義則使用此預設值。",
                                    en: "You can set a default maximum number of checkouts, hold policy and return policy that will be used if none is defined below for a particular item type or category.",
                                },
                                default_checkout_hold_patron_category: {
                                    'zh-tw': "按讀者類別設置預設借閱和預約政策",
                                    en: "Default checkout, hold policy by patron category",
                                },
                                library_max_loans_info: {
                                    'zh-tw': "對於本圖書館，您可以指定某個讀者類別的最大借閱數量，無論館藏類型如何。",
                                    en: "For this library, you can specify the maximum number of loans that a patron of a given category can make, regardless of the item type.",
                                },
                                unlimited_loans_note: {
                                    'zh-tw': "若某個讀者類別的總可借閱數量留空，則不設限，除非為特定館藏類型設定了限額。",
                                    en: "If the total amount loanable for a given patron category is left blank, no limit applies, except possibly for a limit you define for a specific item type.",
                                },
                                default_waiting_hold_cancellation_policy: {
                                    'zh-tw': "預設預約取消政策",
                                    en: "Default waiting hold cancellation policy",
                                },
                                waiting_hold_cancellation_instruction: {
                                    'zh-tw': "指定是否可為特定讀者類別取消等待中的預約。",
                                    en: "Specify if waiting holds can be cancelled for a given patron category.",
                                },
                                default_lost_item_fee_refund_policy: {
                                    'zh-tw': "預設遺失館藏歸還費用退還政策",
                                    en: "Default lost item fee refund on return policy",
                                },
                                lost_item_fee_instruction: {
                                    'zh-tw': "指定遺失館藏歸還時的預設費用退還政策。",
                                    en: "Specify the default policy for lost item fees on return.",
                                },
                                default_holds_policy_by_item_type: {
                                    'zh-tw': "按館藏類型設置預設預約政策",
                                    en: "Default holds policy by item type",
                                },
                                edit_hold_policy_itemtype_info: {
                                    'zh-tw': "對於本圖書館，您可以針對特定館藏類型編輯規則，無論讀者類別如何。",
                                    en: "For this library, you can edit rules for given itemtypes, regardless of the patron's category.",
                                },
                                hold_policy_effects: {
                                    'zh-tw': "目前這意味著預約政策。各政策的效果如下：",
                                    en: "Currently, this means hold policies. The various policies have the following effects:",
                                },
                                from_any_library: {
                                    'zh-tw': "任何圖書館",
                                    en: "From any library",
                                },
                                from_any_library_details: {
                                    'zh-tw': "任何圖書館的讀者均可預約此館藏。（若未定義則使用此為預設）",
                                    en: "Patrons from any library may put this item on hold. (default if none is defined)",
                                },
                                from_local_hold_group: {
                                    'zh-tw': "本地預約群組",
                                    en: "From local hold group",
                                },
                                from_local_hold_group_details: {
                                    'zh-tw': "僅來自館藏屬於同一家庭館的圖書館讀者可預約此書。",
                                    en: "Only patrons from libraries in the same item's home library hold groups may put this book on hold.",
                                },
                                from_home_library: {
                                    'zh-tw': "自家庭圖書館",
                                    en: "From home library",
                                },
                                from_home_library_details: {
                                    'zh-tw': "僅該館藏的家庭圖書館的讀者可預約此書。",
                                    en: "Only patrons from the item's home library may put this book on hold.",
                                },
                                no_holds_allowed: {
                                    'zh-tw': "不允許預約",
                                    en: "No holds allowed",
                                },
                                no_holds_allowed_details: {
                                    'zh-tw': "任何讀者皆無法預約此書。",
                                    en: "No patron may put this book on hold.",
                                },
                                hold_policy_override_note: {
                                    'zh-tw': "注意：",
                                    en: "Note:",
                                },
                                hold_policy_override_details: {
                                    'zh-tw': "如果系統偏好 'AllowHoldPolicyOverride' 被啟用，這些政策可以由流通人員覆蓋。",
                                    en: "If the system preference 'AllowHoldPolicyOverride' is enabled, these policies can be overridden by your circulation staff.",
                                },
                                important_info: {
                                    'zh-tw': "重要事項：",
                                    en: "Important:",
                                },

                                reserves_control_branch_info: {
                                    'zh-tw': "預約政策是基於 ReservesControlBranch 系統偏好來應用，其設置為 PatronLibrary。",
                                    en: "The hold policies are applied based on the ReservesControlBranch system preference which is set to PatronLibrary.",
                                },
                                circ_control_returns_branch_info: {
                                    'zh-tw': "歸還政策是基於 CircControlReturnsBranch 系統偏好來應用，其設置為 ItemHomeLibrary。",
                                    en: "The return policy is applied based on the CircControlReturnsBranch system preference which is set to ItemHomeLibrary.",
                                },
                                item_floats_policy_note: {
                                    'zh-tw': "當歸還政策設為「館藏在圖書館群組間浮動」時，會使用館藏的家庭分館來查找群組。",
                                    en: "When return policy is set to 'item floats by library group' the item's homebranch will be used to find groups.",
                                },

                                select_a_library: {
                                    'zh-tw': "選擇一個圖書館",
                                    en: "Select a library",
                                },
                                clone_rules_to: {
                                    'zh-tw': "將這些規則複製到",
                                    en: "Clone these rules to",
                                },
                                clone: {
                                    'zh-tw': "複製規則",
                                    en: "Clone",
                                },


                                patron_category: {
                                    'zh-tw': "讀者類別",
                                    en: "Patron category",
                                },
                                item_type: {
                                    'zh-tw': "館藏類型",
                                    en: "Item type",
                                },
                                action: {
                                    'zh-tw': "動作",
                                    en: "Action",
                                },
                                note: {
                                    'zh-tw': "備註",
                                    en: "Note",
                                },
                                current_checkouts_allowed: {
                                    'zh-tw': "當前允許的借閱數量",
                                    en: "Current checkouts allowed",
                                },
                                current_on_site_checkouts_allowed: {
                                    'zh-tw': "當前允許的現場借閱數量",
                                    en: "Current on-site checkouts allowed",
                                },
                                loan_period: {
                                    'zh-tw': "借閱期限(天)",
                                    en: "Loan period(Days)",
                                },
                                days_mode: {
                                    'zh-tw': "天數模式",
                                    en: "Days mode",
                                },
                                unit: {
                                    'zh-tw': "單位",
                                    en: "Unit",
                                },
                                hard_due_date_compare: {
                                    'zh-tw': "對比強制借閱到期日(到期日前後)",
                                    en: "Hard due date compare",
                                },
                                hard_due_date: {
                                    'zh-tw': "強制借閱到期日(所有館藏必須於到期日前歸還)",
                                    en: "Hard due date",
                                },
                                decreased_loan_period_for_high_holds: {
                                    'zh-tw': "因大量預約而減少借閱期限（天）",
                                    en: "Decreased loan period for high holds (day)",
                                },
                                fine_amount: {
                                    'zh-tw': "罰金金額",
                                    en: "Fine amount",
                                },
                                fine_charging_interval: {
                                    'zh-tw': "罰金收取間隔(天)",
                                    en: "Fine charging interval(Days)",
                                },
                                when_to_charge: {
                                    'zh-tw': "何時收取",
                                    en: "When to charge",
                                },
                                fine_suspension_grace_period: {
                                    'zh-tw': "罰金暫停寬限期(天)",
                                    en: "Fine suspension grace period(Days)",
                                },
                                overdue_fines_cap: {
                                    'zh-tw': "逾期罰金上限",
                                    en: "Overdue fines cap",
                                },
                                cap_fine_at_replacement_price: {
                                    'zh-tw': "罰金上限為替換價格",
                                    en: "Cap fine at replacement price",
                                },
                                suspension_in_days: {
                                    'zh-tw': "暫停天數(天)",
                                    en: "Suspension in days(Days)",
                                },
                                max_suspension_duration: {
                                    'zh-tw': "最長暫停期限(天)",
                                    en: "Max suspension duration(Days)",
                                },
                                suspension_charging_interval: {
                                    'zh-tw': "暫停收取間隔(天)",
                                    en: "Suspension charging interval(Days)",
                                },
                                renewals_allowed: {
                                    'zh-tw': "允許續借次數",
                                    en: "Renewals allowed",
                                },
                                renewal_period: {
                                    'zh-tw': "續借期限(天)",
                                    en: "Renewal period(Days)",
                                },
                                no_renewal_before: {
                                    'zh-tw': "續借前不得進行(天)",
                                    en: "No renewal before(Days)",
                                },
                                no_automatic_renewal_before: {
                                    'zh-tw': "自動續借前不得進行(天)",
                                    en: "No automatic renewal before(Days)",
                                },
                                automatic_renewal: {
                                    'zh-tw': "自動續借",
                                    en: "Automatic renewal",
                                },
                                no_automatic_renewal_after: {
                                    'zh-tw': "自動續借後不得進行(天)",
                                    en: "No automatic renewal after(Days)",
                                },
                                no_automatic_renewal_after_hard_limit: {
                                    'zh-tw': "硬性限制後無自動續借",
                                    en: "No automatic renewal after hard limit",
                                },
                                holds_allowed_total: {
                                    'zh-tw': "允許的總預約數量",
                                    en: "Holds allowed total",
                                },
                                holds_allowed_daily: {
                                    'zh-tw': "每日允許的預約數量",
                                    en: "Holds allowed daily",
                                },
                                holds_per_record: {
                                    'zh-tw': "每筆紀錄的預約數量",
                                    en: "Holds per record",
                                },
                                onself_holds_allowed: {
                                    'zh-tw': "允許自己預約",
                                    en: "Onself holds allowed",
                                },
                                opac_item_level_holds: {
                                    'zh-tw': "OPAC 館藏層級預約",
                                    en: "Opac item level holds",
                                },
                                holds_pick_up_period: {
                                    'zh-tw': "預約取書期限(天)",
                                    en: "Holds pick-up period(Days)",
                                },
                                rental_discount: {
                                    'zh-tw': "租金折扣",
                                    en: "Rental discount",
                                },


                                total_current_checkouts_allowed: {
                                    'zh-tw': "允許的當前總借閱數量",
                                    en: "Total current checkouts allowed",
                                },
                                total_current_on_site_checkouts_allowed: {
                                    'zh-tw': "允許的當前總現場借閱數量",
                                    en: "Total current on-site checkouts allowed",
                                },
                                maximum_total_holds_allowed_count: {
                                    'zh-tw': "允許的最大總預約數量（次數）",
                                    en: "Maximum total holds allowed (count)",
                                },
                                hold_policy: {
                                    'zh-tw': "預約政策",
                                    en: "Hold policy",
                                },
                                hold_pickup_library_match: {
                                    'zh-tw': "預約取書館配對",
                                    en: "Hold pickup library match",
                                },
                                return_policy: {
                                    'zh-tw': "歸還政策",
                                    en: "Return policy",
                                },


                                total_holds_allowed: {
                                    'zh-tw': "允許的總預約數量",
                                    en: "Total holds allowed",
                                },

                                cancellation_allowed: {
                                    'zh-tw': "允許取消",
                                    en: "Cancellation allowed",
                                },

                                refund_lost_item_replacement_fee: {
                                    'zh-tw': "退還遺失館藏替換費",
                                    en: "Refund lost item replacement fee",
                                },
                                refund_lost_item_processing_fee: {
                                    'zh-tw': "退還遺失館藏處理費",
                                    en: "Refund lost item processing fee",
                                },


                            },
                        }
                    }
                },
                Patron: { ...patron, children: {} },
                Patrons: {
                    ...patrons, children: {
                        CheckOutHistory: {
                            ...checkout,
                            children: {
                                patron: {
                                    'zh-tw': "借書人",
                                    en: "Patron",
                                },
                                previous_step: {
                                    'zh-tw': "上一步",
                                    en: "Previous Step",
                                },
                                address: {
                                    'zh-tw': "地址",
                                    en: "Address",
                                },
                                city: {
                                    'zh-tw': "城市",
                                    en: "City",
                                },
                                phone: {
                                    'zh-tw': "電話",
                                    en: "Phone",
                                },
                                email: {
                                    'zh-tw': "電子郵件",
                                    en: "Email",
                                },
                                birthday: {
                                    'zh-tw': "生日",
                                    en: "Birthday",
                                },
                                type: {
                                    'zh-tw': "類型",
                                    en: "Type",
                                },
                                affiliated_library: {
                                    'zh-tw': "所屬圖書館",
                                    en: "Affiliated Library",
                                },
                                patron_id: {
                                    'zh-tw': "讀者編號",
                                    en: "Patron ID",
                                },
                                last_update_time: {
                                    'zh-tw': "最後更新時間",
                                    en: "Last Update Time",
                                },
                                borrowed_list: {
                                    children: {
                                        return_selected_items: {
                                            'zh-tw': "歸還勾選項目",
                                            en: "Return Selected Items",
                                        },
                                        renew_selected_items: {
                                            'zh-tw': "續借勾選項目",
                                            en: "Renew Selected Items",
                                        },
                                        renew_all_items: {
                                            'zh-tw': "續借所有項目",
                                            en: "Renew All Items",
                                        },
                                        due_date: {
                                            'zh-tw': "到期日",
                                            en: "Due Date",
                                        },
                                        title: {
                                            'zh-tw': "書名",
                                            en: "Title",
                                        },
                                        category: {
                                            'zh-tw': "種類",
                                            en: "Category",
                                        },
                                        collection: {
                                            'zh-tw': "藏書",
                                            en: "Collection",
                                        },
                                        location: {
                                            'zh-tw': "藏書位置",
                                            en: "Location",
                                        },
                                        original_library: {
                                            'zh-tw': "原圖書館",
                                            en: "Original Library",
                                        },
                                        borrow_date: {
                                            'zh-tw': "借出日期",
                                            en: "Borrow Date",
                                        },
                                        borrow_library: {
                                            'zh-tw': "借出圖書館",
                                            en: "Borrow Library",
                                        },
                                        fee: {
                                            'zh-tw': "費用",
                                            en: "Fee",
                                        },
                                        fine: {
                                            'zh-tw': "罰金",
                                            en: "Fine",
                                        },
                                        price: {
                                            'zh-tw': "價格",
                                            en: "Price",
                                        },
                                        action: {
                                            'zh-tw': "操作",
                                            en: "Action",
                                        },
                                        return: {
                                            'zh-tw': "還書",
                                            en: "Return",
                                        },
                                        renew: {
                                            'zh-tw': "續借",
                                            en: "Renew",
                                        }
                                    }
                                }
                            }
                        },
                    }
                },
                NewPatron: {
                    'zh-tw': "新增讀者",
                    en: "New Patron",
                    children: {}
                },
                EditPatron: {
                    'zh-tw': "修改讀者資料",
                    en: "Edit Patron",
                    children: {}
                },
                PatronCategories: { ...patronCategories, children: {} },
                PatronCategory: { ...patronCategory, children: {} },
                serials_management: {
                    'zh-tw': "連續性出版品設定",
                    en: "Serials Management",
                    children: {
                        serials_management: {
                            'zh-tw': "連續性出版品設定",
                            en: "Serials Management",
                        },
                        add: {
                            'zh-tw': "新增",
                            en: "Add",
                        },
                        modify: {
                            'zh-tw': "修改",
                            en: "Modify",
                        },
                        edit: {
                            'zh-tw': "編輯",
                            en: "Edit",
                        },
                        delete: {
                            'zh-tw': "刪除",
                            en: "Delete",
                        },
                        submit: {
                            'zh-tw': "送出",
                            en: "Submit",
                        },
                        add_success: {
                            'zh-tw': "新增成功",
                            en: "Add Successful",
                        },
                        modify_success: {
                            'zh-tw': "修改成功",
                            en: "Modify Successful",
                        },
                        delete_success: {
                            'zh-tw': "刪除成功",
                            en: "Delete Successful",
                        },
                        add_failure: {
                            'zh-tw': "新增失敗",
                            en: "Add Failure",
                        },
                        modify_failure: {
                            'zh-tw': "修改失敗",
                            en: "Modify Failure",
                        },
                        delete_failure: {
                            'zh-tw': "刪除失敗",
                            en: "Delete Failure",
                        },
                        batch_delete: {
                            'zh-tw': "多筆刪除",
                            en: "Batch Delete",
                        },
                        bibliography: {
                            'zh-tw': "書目",
                            en: "Bibliography",
                        },
                        vendor: {
                            'zh-tw': "販賣商",
                            en: "Vendor",
                        },
                        received_serial_number: {
                            'zh-tw': "收到此序號時",
                            en: "When Received Serial Number",
                        },
                        irregular_issue: {
                            'zh-tw': "當出現不正常問題時",
                            en: "When there is an irregular issue",
                        },
                        manual_record_change: {
                            'zh-tw': "是否可以手動變更紀錄",
                            en: "Can Manual Record Change?",
                        },
                        call_number: {
                            'zh-tw': "索書號",
                            en: "Call Number",
                        },
                        library: {
                            'zh-tw': "圖書館",
                            en: "Library",
                        },
                        public_note: {
                            'zh-tw': "公開備註",
                            en: "Public Note",
                        },
                        internal_note: {
                            'zh-tw': "內部備註",
                            en: "Internal Note",
                        },
                        subscriber_notification: {
                            'zh-tw': "訂閱者通知",
                            en: "Subscriber Notification",
                        },
                        shelving_location: {
                            'zh-tw': "擺放位置",
                            en: "Shelving Location",
                        },
                        grace_period: {
                            'zh-tw': "寬限期",
                            en: "Grace Period",
                        },
                        first_issue_publication_date: {
                            'zh-tw': "首次出版日期",
                            en: "First Issue Publication Date",
                        },
                        frequency: {
                            'zh-tw': "發行頻率",
                            en: "Frequency",
                        },
                        subscription_length: {
                            'zh-tw': "訂閱時長",
                            en: "Subscription Length",
                        },
                        subscription_start_date: {
                            'zh-tw': "訂閱開始日期",
                            en: "Subscription Start Date",
                        },
                        subscription_end_date: {
                            'zh-tw': "訂閱結束日期",
                            en: "Subscription End Date",
                        },
                        numbering_pattern: {
                            'zh-tw': "編號模式",
                            en: "Numbering Pattern",
                        },
                        publication_date_template: {
                            'zh-tw': "出版日期模板",
                            en: "Publication Date Template",
                        },


                    }
                },
                serial_frequency_management: {
                    'zh-tw': "刊期管理",
                    en: "Issue Management",
                    children: {
                        add_success: {
                            'zh-tw': "新增成功",
                            en: "Add Successful",
                        },
                        modify_success: {
                            'zh-tw': "修改成功",
                            en: "Modify Successful",
                        },
                        delete_success: {
                            'zh-tw': "刪除成功",
                            en: "Delete Successful",
                        },
                        add_failure: {
                            'zh-tw': "新增失敗",
                            en: "Add Failure",
                        },
                        modify_failure: {
                            'zh-tw': "修改失敗",
                            en: "Modify Failure",
                        },
                        delete_failure: {
                            'zh-tw': "刪除失敗",
                            en: "Delete Failure",
                        },
                        serial_frequency_management: {
                            'zh-tw': "刊期管理",
                            en: "Issue Management",
                        },
                        description: {
                            'zh-tw': "描述",
                            en: "Description",
                        },
                        unit: {
                            'zh-tw': "單位",
                            en: "Unit",
                        },
                        issues_per_unit: {
                            'zh-tw': "每單位期數",
                            en: "Issues per Unit",
                        },
                        units_per_issue: {
                            'zh-tw': "每期單位數",
                            en: "Units per Issue",
                        },
                        display_order: {
                            'zh-tw': "顯示順序",
                            en: "Display Order",
                        },
                        please_enter: {
                            'zh-tw': "請輸入",
                            en: "Please Enter",
                        },
                        please_select: {
                            'zh-tw': "請選擇",
                            en: "Please Select",
                        },
                        note_one_field_must_be_one: {
                            'zh-tw': "注意：以下兩個欄位之一必須等於 1",
                            en: "Note: One of the following two fields must equal 1",
                        }
                    }
                },
                serial_code_management: {
                    'zh-tw': "期刊編碼管理",
                    en: "Serial Code Management",
                    children: {
                        add_success: {
                            'zh-tw': "新增成功",
                            en: "Add Successful",
                        },
                        modify_success: {
                            'zh-tw': "修改成功",
                            en: "Modify Successful",
                        },
                        delete_success: {
                            'zh-tw': "刪除成功",
                            en: "Delete Successful",
                        },
                        add_failure: {
                            'zh-tw': "新增失敗",
                            en: "Add Failure",
                        },
                        modify_failure: {
                            'zh-tw': "修改失敗",
                            en: "Modify Failure",
                        },
                        delete_failure: {
                            'zh-tw': "刪除失敗",
                            en: "Delete Failure",
                        },
                        name: {
                            'zh-tw': "名稱",
                            en: "Name",
                        },
                        description: {
                            'zh-tw': "描述",
                            en: "Description",
                        },
                        numbering_formula: {
                            'zh-tw': "編號公式",
                            en: "Numbering Formula",
                        },
                        display_order: {
                            'zh-tw': "顯示順序",
                            en: "Display Order",
                        },
                        label: {
                            'zh-tw': "標籤",
                            en: "Label",
                        },
                        add: {
                            'zh-tw': "每次添加",
                            en: "Add",
                        },
                        every: {
                            'zh-tw': "每經過幾次",
                            en: "Every",
                        },
                        set_back_to: {
                            'zh-tw': "重設為",
                            en: "Set Back to",
                        },
                        when_more_than: {
                            'zh-tw': "當大於",
                            en: "When More Than",
                        },
                        formatting: {
                            'zh-tw': "格式化",
                            en: "Formatting",
                        },
                        preview_code_settings_display: {
                            'zh-tw': "預覽編碼設定呈現",
                            en: "Preview Code Settings Display",
                        },
                        serial_code_setting: {
                            'zh-tw': "編碼設定",
                            en: "Serial Code Setting"
                        },
                        first_issue_publication_date: {
                            'zh-tw': "首次出版日期",
                            en: "First Issue Publication Date",
                        },
                        frequency: {
                            'zh-tw': "發行頻率",
                            en: "Frequency",
                        },
                        subscription_length: {
                            'zh-tw': "訂閱時長",
                            en: "Subscription Length",
                        },
                        begins_with: {
                            'zh-tw': "開始於",
                            en: "Begins With",
                        },
                        inner_counter: {
                            'zh-tw': "內部計數器",
                            en: "Inner Counter",
                        },
                        number: {
                            'zh-tw': "編號",
                            en: "Number",
                        },
                        publication_date: {
                            'zh-tw': "出版日期",
                            en: "Publication Date",
                        },
                        generate_preview: {
                            'zh-tw': "產生預覽",
                            en: "Generate Preview",
                        }
                    }
                },
                ...language_cataloging.children,
                library_transfer_limit_management: {
                    'zh-tw': "館際轉移限制管理",
                    en: "Library Transfer Limit Management",
                    children: {
                        library_transfer_limit_management: {
                            'zh-tw': "館際轉移限制管理",
                            en: "Library Transfer Limit Management",
                        },
                        add_success: {
                            'zh-tw': "新增成功",
                            en: "Add Successful",
                        },
                        modify_success: {
                            'zh-tw': "修改成功",
                            en: "Modify Successful",
                        },
                        delete_success: {
                            'zh-tw': "刪除成功",
                            en: "Delete Successful",
                        },
                        add_failure: {
                            'zh-tw': "新增失敗",
                            en: "Add Failure",
                        },
                        modify_failure: {
                            'zh-tw': "修改失敗",
                            en: "Modify Failure",
                        },
                        delete_failure: {
                            'zh-tw': "刪除失敗",
                            en: "Delete Failure",
                        },
                        transfer_out_library: {
                            'zh-tw': "轉出館際",
                            en: "Transfer Out Library",
                        },
                        transfer_in_library: {
                            'zh-tw': "轉入館際",
                            en: "Transfer In Library",
                        },
                        is_transferable: {
                            'zh-tw': "可否轉移",
                            en: "Is Transferable",
                        },
                        special_collection_classification: {
                            'zh-tw': "特藏分類",
                            en: "Special Collection Classification",
                        }
                    }
                },
                library_transfer_management: {
                    'zh-tw': "館際轉移管理",
                    en: "Library Transfer Limit Management",
                    children: {
                        library_transfer_management: {
                            'zh-tw': "館際轉移管理",
                            en: "Library Transfer Limit Management",
                        },
                        add_success: {
                            'zh-tw': "新增成功",
                            en: "Add Successful",
                        },
                        modify_success: {
                            'zh-tw': "修改成功",
                            en: "Modify Successful",
                        },
                        delete_success: {
                            'zh-tw': "刪除成功",
                            en: "Delete Successful",
                        },
                        add_failure: {
                            'zh-tw': "新增失敗",
                            en: "Add Failure",
                        },
                        modify_failure: {
                            'zh-tw': "修改失敗",
                            en: "Modify Failure",
                        },
                        delete_failure: {
                            'zh-tw': "刪除失敗",
                            en: "Delete Failure",
                        },
                        transfer_out_library: {
                            'zh-tw': "轉出館際",
                            en: "Transfer Out Library",
                        },
                        transfer_in_library: {
                            'zh-tw': "轉入館際",
                            en: "Transfer In Library",
                        },
                        is_transferable: {
                            'zh-tw': "可否轉移",
                            en: "Is Transferable",
                        },
                        special_collection_classification: {
                            'zh-tw': "特藏分類",
                            en: "Special Collection Classification",
                        },
                        transfer_out_date: {
                            'zh-tw': "轉出日期",
                            en: "Transfer Out Date",
                        },
                        received_date: {
                            'zh-tw': "接收日期",
                            en: "Received Date",
                        },
                        is_reserved: {
                            'zh-tw': "是否有預約",
                            en: "Is Reserved",
                        },
                        collection_name: {
                            'zh-tw': "館藏名稱",
                            en: "Collection Name",
                        },
                        call_number: {
                            'zh-tw': "索書號",
                            en: "Call Number",
                        },
                        barcode: Barcode,
                        bibliography: {
                            'zh-tw': "書目",
                            en: "Bibliography",
                        },
                        confirm_receipt: {
                            'zh-tw': "確認接收",
                            en: "Confirm Receipt",
                        }
                    }
                },
                authorized_values_management: {
                    'zh-tw': "授權值管理",
                    en: "Authorized Values Management",
                    children: {
                        authorized_values_management: {
                            'zh-tw': "授權值管理",
                            en: "Authorized Values Management"
                        },
                        category: {
                            'zh-tw': "類別",
                            en: "Category",
                        },
                        description: {
                            'zh-tw': "描述",
                            en: "Description",
                        },
                        add: {
                            'zh-tw': "新增",
                            en: "Add",
                        },
                        authorized_values: {
                            'zh-tw': "授權值",
                            en: "Authorized Values",
                        },
                        new_category: {
                            'zh-tw': "新增授權值類別",
                            en: "New Category",
                        },
                        authorised_value: {
                            'zh-tw': "授權值",
                            en: "Authorised Value",
                        },
                        description_opac: {
                            'zh-tw': "描述（OPAC）",
                            en: "Description (OPAC)",
                        },
                        library_information: {
                            'zh-tw': "圖書館資訊",
                            en: "Library Information",
                        },
                        delete: {
                            'zh-tw': "刪除",
                            en: "Delete",
                        },
                        edit: {
                            'zh-tw': "編輯",
                            en: "Edit",
                        },
                        cancel: {
                            'zh-tw': "取消",
                            en: "Cancel",
                        },
                        show_category: {
                            'zh-tw': "顯示類別",
                            en: "Show Category",
                        },
                        library_limitations: {
                            'zh-tw': "圖書館限制",
                            en: "Library Limitations",
                        }

                    }
                },
                department_patron_categories: {
                    'zh-tw': "系統角色（讀者類型）設定",
                    en: "",
                    children: {
                        home: {
                            'zh-tw': "個人資料維護",
                            en: "",
                            children: {
                            }
                        },
                        permission_management: {
                            'zh-tw': "系統功能權限設定",
                            en: "",
                            children: {
                            }
                        },

                        permission_statistic: {
                            'zh-tw': "權限統計",
                            en: "permission_statistic",
                            children: {},
                        },
                    }
                },
                staff: {
                    'zh-tw': "人員基本資料設定",
                    en: "",
                    children: {
                    }
                },
                role: {
                    'zh-tw': "職稱設定",
                    en: "",
                    children: {
                        default_role: {
                            'zh-tw': "共用職稱",
                            en: "",
                        },
                        depth: {
                            children: {
                                data: {
                                    'zh-tw': "層級資訊",
                                    en: "",
                                },
                                get: {
                                    'zh-tw': "查詢",
                                    en: "",
                                },
                                post: {
                                    'zh-tw': "新增",
                                    en: "",
                                },
                                patch: {
                                    'zh-tw': "編輯",
                                    en: "",
                                },
                                delete: {
                                    'zh-tw': "刪除",
                                    en: "",
                                },
                                submit: {
                                    'zh-tw': "確認",
                                    en: "",
                                },
                                cancel: {
                                    'zh-tw': "取消",
                                    en: "",
                                },
                            }
                        },

                    }
                },
                depth: {
                    'zh-tw': "層級資料設定",
                    en: "",
                    children: {

                    }
                },
                staff_patron: {
                    'zh-tw': "人員基本資料設定",
                    en: "",
                    children: {

                        cardnumber: {
                            'zh-tw': "卡號",
                            en: "Card Number",
                        },
                        branchcode: {
                            'zh-tw': "分館代碼",
                            en: "Branch Code",
                        },
                        branchname: {
                            'zh-tw': "所屬分館",
                            en: "Branch Name",
                        },
                        borrowercategory: {
                            'zh-tw': "讀者分類",
                            en: "Borrower Category",
                        },
                        borrowernumber: {
                            'zh-tw': "讀者編號",
                            en: "Borrower Number",
                        },
                        dateexpiry: {
                            'zh-tw': "帳號過期日",
                            en: "Expiration date",
                        },
                        expired: {
                            'zh-tw': "帳號已過期",
                            en: "Expired",
                        },
                    }
                },
                frontend_basic_settings: {
                    ...frontend_basic_settings,
                    children: {
                        question_and_answer: {
                            'zh-tw': "Q&A管理",
                            en: "Q&A Management",
                            children: {

                            }
                        },
                        ...language_utility,
                        news: {

                            'zh-tw': "最新消息管理",
                            en: "",
                            children: {}
                        }

                    }
                },
                backend_basic_settings: {
                    ...backend_basic_settings,
                    children:{
                        ...language_koha?.children,
                    }
                },
                library: {
                    ...language_koha?.children?.library
                },
                authorised_category: {
                    ...language_koha?.children?.authorized_category_management
                },
                authorised_category_value: {
                    ...language_koha?.children?.authorized_category_values_management
                },


            }
        },
        home: {
            'zh-tw': "圖書自動化系統",
            en: "Library Automation System",
            children: {
                cataloging: cataloging,
                circulation: circulation,
                patrons: patrons,
            }
        },
        cardView: {
            'zh-tw': "",
            en: "",
            children: {
                TitlePreview: {
                    'zh-tw': "書目預覽",
                    en: "Title Preview"
                },
                Author: Author,
                Keyword: Keyword,
                Year: Year,
                Edition: Year,
                Actions: Actions,
            }
        },
        cataloging: {
            cataloging,
            children: {
                cataloging: cataloging,
                add_record: add_record,
                import_bib: {
                    'zh-tw': "匯入書目",
                    en: "Import Record"
                },
                manage_bib: {
                    'zh-tw': "管理書目",
                    en: "Manage Record"
                },
                label_bib: {
                    'zh-tw': "標籤製作",
                    en: "Label Record"
                },
                print_label_bib: {
                    'zh-tw': "產生條碼",
                    en: "Print Label Record"
                },
                default_format: {
                    'zh-tw': "預設格式",
                    en: "Default Format"
                },
                defined_format: {
                    'zh-tw': "自訂格式",
                    en: "Defined Format"
                },

            },
        },

        addmarc: {
            'zh-tw': "",
            en: "",
            children: {
                add_record: add_record,
                edit_record: edit_record,
                save_record: {
                    'zh-tw': "儲存書目",
                    en: "Save Record"
                },
                search_z3950: search_z3950,
            }
        },
        stage_marc_record: {
            'zh-tw': "",
            en: "",
            children: {
                Stage_MARC_records_for_import: {
                    'zh-tw': "匯入 MARC 記錄",
                    en: "Stage MARC records for import"
                },
                Select_a_MARC_file_to_stage_in_the_import_reservoir_It_will_be_parsed_and_each_valid_record_staged_for_later_import_into_the_catalog: {
                    'zh-tw': "匯入 MARC 記錄選擇一個MARC檔案，將其進行暫存。該檔案將被解析，每個有效的記錄將被暫存以便稍後導入目錄。",
                    en: "Select a MARC file to stage in the import reservoir. It will be parsed, and each valid record staged for later import into the catalog."
                },
                You_can_enter_a_name_for_this_import_It_may_be_useful_when_creating_a_record_to_remember_where_the_suggested_MARC_data_comes_from: {
                    'zh-tw': "您可以為此匯入輸入名稱。在建立記錄時，記住建議的 MARC 資料來自何處可能很有用！",
                    en: "You can enter a name for this import. It may be useful, when creating a record, to remember where the suggested MARC data comes from"
                },
                upload_file: {
                    'zh-tw': "確認上傳",
                    en: "Upload File"
                },
                "最後暫存時間": {
                    'zh-tw': "最後暫存時間",
                    en: "最後暫存時間"
                },
                "最後暫存筆數": {
                    'zh-tw': "最後暫存筆數",
                    en: "最後暫存筆數"
                },
                "內含重複筆數": {
                    'zh-tw': "內含重複筆數",
                    en: "內含重複筆數"
                },
                "重複書目清單": {
                    'zh-tw': "重複書目清單",
                    en: "重複書目清單"
                },
                "uploadResult": {
                    'zh-tw': "上傳完成. 失敗 failedCount 筆. 其中含重複書目 DuplicateCount 筆.",
                    en: "上傳完成. 失敗 failedCount 筆. 其中含重複書目 DuplicateCount 筆."
                },
            }
        },
        manage_marc_record: {
            'zh-tw': "",
            en: "",
            children: {
                manage_marc_record: {
                    'zh-tw': "管理書目",
                    en: "Manage Marc Record"
                },
                post_bib: {
                    'zh-tw': "新增書目",
                    en: "Add Record"
                },
                results: {
                    'zh-tw': "結果",
                    en: "Results"
                },
                Author: Author,
                Material_type: {
                    'zh-tw': "資料類型",
                    en: "Material type"
                },
                Language: {
                    'zh-tw': "語言",
                    en: "Language"
                },
                Series: {
                    'zh-tw': "集叢名",
                    en: "Series"
                },
                Publication_details: Publication_details,
                Description: Description,
                Edition: Edition,
                Other_title: Other_title,
                ISBN: {
                    'zh-tw': "ISBN",
                    en: "ISBN"
                },
                location: {
                    'zh-tw': "位置",
                    en: "Location"
                },
                No_items: {
                    'zh-tw': "沒有館藏",
                    en: "No items"
                },
                borrowed: {
                    'zh-tw': "已借出",
                    en: "Borrowed"
                },
                available: {
                    'zh-tw': "可借出",
                    en: "available"
                },
                item: {
                    'zh-tw': "館藏",
                    en: "Item"
                },
                import_bibliography_date: {
                    'zh-tw': "匯入書目日期",
                    en: "Import Bibliography Date",
                },
                time_end: {
                    'zh-tw': "結束時間",
                    en: "Time End",
                },
                time_start: {
                    'zh-tw': "開始時間",
                    en: "Time Start",
                },
                bib_translator: {
                    'zh-tw': "譯者",
                    en: "Bibliographic Translator",
                }
            }
        },

        bookdetail: {
            'zh-tw': "",
            en: "",
            children: {
                Material_type: Material_type,
                Series: Series,
                Publication_details: Publication_details,
                Edition: Edition,
                Description: Description,
                Other_title: Other_title,
                Subject: Subject,
                Author: Author,
                ISBN: {
                    'zh-tw': "ISBN",
                    en: "ISBN"
                },
                Language: {
                    'zh-tw': "語言",
                    en: "Language"
                },
                bib_translator: {
                    'zh-tw': "譯者",
                    en: "Bibliographic Translator",
                },
                import_bibliography_date: {
                    'zh-tw': "匯入書目日期",
                    en: "Import Bibliography Date",
                },
                "Other classification": {
                    'zh-tw': "其他分類",
                    en: "Other classification"
                },
                "MARC preview": {
                    'zh-tw': "MARC 預覽",
                    en: "MARC preview"
                },
                "MARC framework": {
                    'zh-tw': "MARC 框架",
                    en: "MARC framework"
                },
                Holding: {
                    'zh-tw': "館藏",
                    en: "Holding"
                },
                Descriptions: {
                    'zh-tw': "題名附註",
                    en: "Descriptions"
                },
                "Acquisition details": {
                    'zh-tw': "取得細節",
                    en: "Acquisition details"
                },
                "Images": {
                    'zh-tw': "圖片",
                    en: "Images"
                },
                "Upload an image file": {
                    'zh-tw': "上傳圖片",
                    en: "Upload an image file"
                },
                Item_type: Item_type,
                "Current library": {
                    'zh-tw': "現行圖書館",
                    en: "Current library"
                },
                "Home library": {
                    'zh-tw': "所屬分館",
                    en: "Home library"
                },
                Item_call_number: Item_call_number,
                "Status": {
                    'zh-tw': "狀態",
                    en: "Status"
                },
                "CanCheckout": {
                    'zh-tw': "可借出",
                    en: "Can Checkout"
                },
                "CantCheckout": {
                    'zh-tw': "借出中",
                    en: "Can't Checkout"
                },
                "Last seen": {
                    'zh-tw': "最後一次查看",
                    en: "Last seen"
                },
                "Date accessioned": {
                    'zh-tw': "建立日期",
                    en: "Accession date"
                },
                "Date last borrowed": {
                    'zh-tw': "最後一次借出",
                    en: "Last borrowed"
                },
                Barcode: Barcode,
                "Copy number": {
                    'zh-tw': "複本號",
                    en: "Copy number"
                },
                "Call_number": {
                    'zh-tw': "索書號",
                    en: "Call Number"
                },
                withdrawn_status: {
                    'zh-tw': "停用狀態",
                    en: "Withdrawn Status",
                },
                source_classification_shelving_scheme: {
                    'zh-tw': "分類或上架方案來源",
                    en: "Source of Classification or Shelving Scheme",
                },
                specified_materials: {
                    'zh-tw': "指定材料（裝訂卷冊或其他部分）",
                    en: "Materials Specified (Bound Volume or Other Part)",
                },
                damaged_status: {
                    'zh-tw': "損壞狀態",
                    en: "Damaged Status",
                },
                use_restrictions: {
                    'zh-tw': "使用限制",
                    en: "Use Restrictions",
                },
                not_for_loan: {
                    'zh-tw': "不外借",
                    en: "Not for Loan",
                },
                collection: {
                    'zh-tw': "館藏",
                    en: "Collection",
                },
                home_library: {
                    'zh-tw': "所屬圖書館",
                    en: "Home Library",
                },
                current_library: {
                    'zh-tw': "當前所在圖書館",
                    en: "Current Library",
                },
                shelving_location: {
                    'zh-tw': "擺放位置",
                    en: "Shelving Location",
                },
                date_acquired: {
                    'zh-tw': "入館日期",
                    en: "Date Acquired",
                },
                source_acquisition: {
                    'zh-tw': "取得來源",
                    en: "Source of Acquisition",
                },
                coded_location_qualifier: {
                    'zh-tw': "地點代碼",
                    en: "Coded Location Qualifier",
                },
                cost_normal_price: {
                    'zh-tw': "成本，正常購買價格",
                    en: "Cost, Normal Purchase Price",
                },
                serial_enumeration_chronology: {
                    'zh-tw': "期刊編號 / 時序",
                    en: "Serial Enumeration / Chronology",
                },
                inventory_number: {
                    'zh-tw': "庫存號",
                    en: "Inventory Number",
                },
                shelving_control_number: {
                    'zh-tw': "架位控制號",
                    en: "Shelving Control Number",
                },
                full_call_number: {
                    'zh-tw': "完整索書號",
                    en: "Full Call Number",
                },
                barcode: {
                    'zh-tw': "條碼",
                    en: "Barcode",
                },
                copy_number: {
                    'zh-tw': "複本號",
                    en: "Copy Number",
                },
                uniform_resource_identifier: {
                    'zh-tw': "統一資源標識符",
                    en: "Uniform Resource Identifier",
                },
                replacement_cost: {
                    'zh-tw': "成本，替換價格",
                    en: "Cost, Replacement Price",
                },
                price_effective_from: {
                    'zh-tw': "價格生效日期",
                    en: "Price Effective From",
                },
                non_public_note: {
                    'zh-tw': "內部備註",
                    en: "Non-Public Note",
                },
                item_type: {
                    'zh-tw': "館藏類型",
                    en: "Item Type",
                },
                public_note: {
                    'zh-tw': "公開備註",
                    en: "Public Note",
                },
                import_collection: {
                    'zh-tw': "匯入館藏",
                    en: "Import Collection",
                },
                export_collection: {
                    'zh-tw': "匯出資料",
                    en: "Export Collection",
                },
            }
        },
        bookdetailitems: {
            'zh-tw': "",
            en: "",
            children: {
                "CanCheckout": {
                    'zh-tw': "可借出",
                    en: "Can Checkout"
                },
                "CantCheckout": {
                    'zh-tw': "借出中",
                    en: "Can't Checkout"
                },
                Biblionumber: {
                    'zh-tw': "書目序號",
                    en: "Biblionumber"
                },
                Publication_details: Publication_details,
                "Physical details": {
                    'zh-tw': "規格細節",
                    en: "Physical details"
                },
                NoOfItems: {
                    'zh-tw': "項目序號",
                    en: "No. of items"
                },
                Barcode: Barcode,
                "Item information": {
                    'zh-tw': "",
                    en: "",
                    children: {
                        "Item information": {
                            'zh-tw': "項目資訊",
                            en: "Item information"
                        },
                        Item_type: Item_type,
                        "Home library": {
                            'zh-tw': "所屬分館",
                            en: "Home library"
                        },
                        Item_call_number: Item_call_number,
                        "Replacement price": {
                            'zh-tw': "重購價格",
                            en: "Replacement price"
                        },
                    }
                },
                Statuses: {
                    'zh-tw': "",
                    en: "",
                    children: {
                        Statuses: {
                            'zh-tw': "狀態",
                            en: "Statuses"
                        },
                        "Current library": {
                            'zh-tw': "現行圖書館",
                            en: "Current library"
                        },
                        "Checkout status": {
                            'zh-tw': "借出狀態",
                            en: "Checkout status"
                        },
                        "Current renewals": {
                            'zh-tw': "續借次數",
                            en: "Current renewals"
                        },
                        "Lost status": {
                            'zh-tw': "遺失狀態",
                            en: "Lost status"
                        },
                        "Damaged status": {
                            'zh-tw': "損壞狀態",
                            en: "Damaged status"
                        },
                        "Withdrawn status": {
                            'zh-tw': "停用狀態",
                            en: "Withdrawn status"
                        },
                        "Set Status": {
                            'zh-tw': "設定狀態",
                            en: "Set Status"
                        },
                    }
                },
                History: {
                    'zh-tw': "",
                    en: "",
                    children: {
                        History: {
                            'zh-tw': "歷史記錄",
                            en: "History"
                        },
                        "Accession date": {
                            'zh-tw': "建立日期",
                            en: "Accession date"
                        },
                        "Total checkouts": {
                            'zh-tw': "總共借出",
                            en: "Total checkouts"
                        },
                        "View item's checkout history": {
                            'zh-tw': "檢視借出歷史記錄",
                            en: "View item's checkout history"
                        },
                        "Current renewals": {
                            'zh-tw': "續借次數",
                            en: "Current renewals"
                        },
                        "Last seen": {
                            'zh-tw': "最後一次查看",
                            en: "Last seen"
                        },
                        "Last borrowed": {
                            'zh-tw': "最後一次借出",
                            en: "Last borrowed"
                        },
                        "Public note": {
                            'zh-tw': "公開備註",
                            en: "Public note"
                        },
                        "Non public note": {
                            'zh-tw': "非公開備註",
                            en: "Public note"
                        },
                        "Type your message here": {
                            'zh-tw': "請輸入備註.",
                            en: "Type your message here."
                        },
                    }
                },

            }
        },

        searchZ3950: {
            'zh-tw': "",
            en: "",
            children: {
                Title: Title,
                Author: Author,
                Keyword: Keyword,
                Year: Year,
                Edition: Edition,
                Actions: Actions,

            }
        },

        labelPrint: {
            'zh-tw': "",
            en: "",
            children: {
                Subject: Subject,
                Author: Author,
                Item_type: Item_type,
                Item_call_number: Item_call_number,
                Actions: Actions,
                New_Record: {
                    'zh-tw': "新增項目",
                    en: "New Record"
                },
                description: {
                    'zh-tw': "標籤群組描述",
                    en: "Description"
                },
                mode: {
                    'zh-tw': "輸入模式",
                    en: "Mode"
                },
                barcode: Barcode,
                item_number: {
                    'zh-tw': "項目編號",
                    en: "Item number"
                },
                input_code: {
                    'zh-tw': "項目編號",
                    en: "Item number"
                },
                lable_number: {
                    'zh-tw': "標籤號碼",
                    en: "Lable number"
                },
                print_all: {
                    'zh-tw': "列印全部項目",
                    en: "Print all"
                },
                clear_all: {
                    'zh-tw': "清除項目",
                    en: "Clear all"
                },
            }
        },
        authority: {
            'zh-tw': "權威控制",
            en: "Authority",
            children: {
                searchAuthority: {
                    'zh-tw': "權威控制",
                    en: "authority",
                    children: {

                        Scope: {
                            'zh-tw': "範圍",
                            en: "Scope"
                        },
                        mainHeadingA: {
                            'zh-tw': "主要標頭 (僅針對 $a)",
                            en: "Main heading ($a only)"
                        },
                        mainHeading: {
                            'zh-tw': "主要標頭",
                            en: "Main heading"
                        },
                        allHeading: {
                            'zh-tw': "全部標頭",
                            en: "All heading"
                        },
                        Keyword: Keyword,
                        Summary: {
                            'zh-tw': "摘要",
                            en: "Summary"
                        },
                        Heading_type: {
                            'zh-tw': "權威類型",
                            en: "Heading type"
                        },
                        Used_in: {
                            'zh-tw': "關連數量",
                            en: "Used in"
                        },
                        Actions: Actions,
                        authority_type: {
                            'zh-tw': "權威類型",
                            en: "Authority Type",
                        },
                        ...finishMessage,
                        search: {
                            'zh-tw': "搜尋",
                            en: "Search",
                        },
                        cancel: {
                            'zh-tw': "取消",
                            en: "Cancel",
                        }


                    }
                },

            }
        },

        online_public_catalog_query_construction: {
            'zh-tw': "線上公用目錄模組",
            en: "",
            children: {
                collection_search: {
                    'zh-tw': "館藏查詢",
                    en: "Collection Search",
                    children: {
                        ...language_koha?.children?.bib_infomation?.children,
                        author: {
                            'zh-tw': "作者",
                            en: "Author",
                        },
                        data_type: {
                            'zh-tw': "資料類型",
                            en: "Data Type",
                        },
                        series_title: {
                            'zh-tw': "集叢名",
                            en: "Series Title",
                        },
                        publication_details: {
                            'zh-tw': "出版細節",
                            en: "Publication Details",
                        },
                        edition: {
                            'zh-tw': "版本",
                            en: "Edition",
                        },
                        description: {
                            'zh-tw': "說明",
                            en: "Description",
                        },
                        isbn: {
                            'zh-tw': "ISBN",
                            en: "ISBN",
                        },
                        other_titles: {
                            'zh-tw': "其他題名",
                            en: "Other Titles",
                        },
                        subject: {
                            'zh-tw': "主題",
                            en: "Subject",
                        },
                        bib_title: {
                            'zh-tw': "書名",
                            en: "Title",
                        },
                        other_classifications: {
                            'zh-tw': "其他分類",
                            en: "Other Classifications",
                        },
                        marc_preview: {
                            'zh-tw': "MARC 預覽",
                            en: "MARC Preview",
                        },
                        marc_framework: {
                            'zh-tw': "MARC 框架",
                            en: "MARC Framework",
                        },
                        Material_type: Material_type,
                        Series: Series,
                        Publication_details: Publication_details,
                        Edition: Edition,
                        Description: Description,
                        Other_title: Other_title,
                        Subject: Subject,
                        "Other classification": {
                            'zh-tw': "其他分類",
                            en: "Other classification"
                        },
                        "MARC preview": {
                            'zh-tw': "MARC 預覽",
                            en: "MARC preview"
                        },
                        "MARC framework": {
                            'zh-tw': "MARC 框架",
                            en: "MARC framework"
                        },
                        Holding: {
                            'zh-tw': "館藏",
                            en: "Holding"
                        },
                        Descriptions: {
                            'zh-tw': "題名附註",
                            en: "Descriptions"
                        },
                        "Acquisition details": {
                            'zh-tw': "取得細節",
                            en: "Acquisition details"
                        },
                        "Images": {
                            'zh-tw': "圖片",
                            en: "Images"
                        },
                        "Upload an image file": {
                            'zh-tw': "上傳圖片",
                            en: "Upload an image file"
                        },
                        Item_type: Item_type,
                        "Current library": {
                            'zh-tw': "現行圖書館",
                            en: "Current library"
                        },
                        "Home library": {
                            'zh-tw': "所屬分館",
                            en: "Home library"
                        },
                        Item_call_number: Item_call_number,
                        "Status": {
                            'zh-tw': "狀態",
                            en: "Status"
                        },
                        "CanCheckout": {
                            'zh-tw': "可借出",
                            en: "Can Checkout"
                        },
                        "CantCheckout": {
                            'zh-tw': "借出中",
                            en: "Can't Checkout"
                        },
                        "Last seen": {
                            'zh-tw': "最後一次查看",
                            en: "Last seen"
                        },
                        "Date accessioned": {
                            'zh-tw': "建立日期",
                            en: "Accession date"
                        },
                        "Date last borrowed": {
                            'zh-tw': "最後一次借出",
                            en: "Last borrowed"
                        },
                        Barcode: Barcode,
                        "Copy number": {
                            'zh-tw': "複本號",
                            en: "Copy number"
                        },
                        call_number: {
                            'zh-tw': "索書號",
                            en: "Call Number",
                        },
                        "action": {
                            'zh-tw': "操作",
                            en: "Action"
                        },
                        "hold": {
                            'zh-tw': "預約",
                            en: "Hold"
                        },
                        "ok": {
                            'zh-tw': "確定",
                            en: "Okay"
                        },
                        "cancel": {
                            'zh-tw': "取消",
                            en: "Cancel"
                        },
                        "borrowernumber": {
                            'zh-tw': "讀者編號",
                            en: "Borrowernumber"
                        },
                        "pickupLibrary": {
                            'zh-tw': "領取校區",
                            en: "Pickup Library"
                        },
                    }
                }
            }
        }
    }
}
export default language_library
